export { default } from '@mui/private-theming/useTheme';